import { format } from 'date-fns';
import DateFormats from './DateFormats';

export default class Base {
  getDateFromSQL(value: string, dateFormat: string) {
    if (!value) {
      return null;
    }
    const _format = dateFormat || DateFormats.DATE_FULL;
    return format(new Date(value.replace(/-/g, '/')), _format);
  }
}
